<template>
    <div>
        <h1>{{ $t('betalingfejl')}}</h1>
        <p>{{ $t('bookingikkelavet') }}</p>
        
        <!-- Vis 'loading' ikon mens API data loader... -->
        <!-- <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt=""> -->

    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
        };
    },
    created() {
    },
    methods: {
    }
}
</script>

<style scoped>

.paymentContainer {
    justify-content: center;
    margin-top: 100px;
    display: flex;
    flex-direction: row;
}

@media screen and (max-width: 640px) {
    .paymentContainer {
        display: flex;
        flex-direction: column;
    }
}

.headerText {
    font-size: 180%;
    margin-bottom: 0px;
    margin-top: 10px;
}

.priceText {
    margin-top: 0px;
    margin-bottom: 5px;
    font-size: 90%;

}

.subText {
    font-size: 50%;
}

.paymentOption {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 300px;
  height: 140px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 150%;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding: 7px;
  margin: 10px;
  display: flex;
  flex-direction: column;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 293px;
  height: 80px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 150%;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 50px;
  margin-left: 0px;
  margin-right: 5%;
  float: right;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
}


</style>